import React, { useState } from "react";
import styles from "../GetInvolved/getInvolved.module.css";
import InvestmentForm from "./InvestmentForm";
import EnterpriseForm from "./EnterpriseForm";
import ResellerForm from "./ResellerForm";
import WhiteLabelForm from "./WhiteLabelForm";
import Modal1 from "./Modal1";
import ThankYouModal from "./ThankYouModal";
export function clickAgentButton(retries = 120) {
  document.body.classList.remove("hide-rex-widget");
  if (window.REX) {
    window.REX.show?.();
  }
  function tryClick(remaining) {
    const el = document.getElementById("agentButton");
    if (!el) {
      if (remaining > 0) {
        requestAnimationFrame(() => tryClick(remaining - 1));
      }
      return false;
    }
    el.style.display = "block";

    if (window.__rex_clicking) return true;
    window.__rex_clicking = true;
    setTimeout(() => {
      window.__rex_clicking = false;
    }, 200);

    const evt = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    el.dispatchEvent(evt);
    return true;
  }

  return tryClick(retries);
}

const GetInvolved = () => {
  const [openModal, setOpenModal] = useState(null);
  const [thankYouOpen, setThankYouOpen] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const closeThankYou = () => setThankYouOpen(false);
  const [lastFormTitle, setLastFormTitle] = useState(null);

  const showThankYou = (email, formTitle) => {
    setUserEmail(email || "");
    setLastFormTitle(formTitle || null);
    setThankYouOpen(true);
    setOpenModal(null);
  };

  const handleTryAgain = () => {
    setThankYouOpen(false);
    if (lastFormTitle) {
      setOpenModal(lastFormTitle);
    }
  };

  const boxes = [
    {
      icon: "/Svg/enterprise-icon.svg",
      title: "Enterprise Solution",
      desc: "Explore Rexpt Enterprise Solution",
    },
    {
      icon: "/Svg/partner-icon.svg",
      title: "Reseller Program",
      desc: "Build Your own Profitable & Future-Ready business",
    },
    {
      icon: "/Svg/whitelabel-icon.svg",
      title: "Whitelabel",
      desc: "For BPOs, Call Centers & Bulk Telemarketers only",
    },
    {
      icon: "/Svg/document-icon.svg",
      title: "Investment Pitch",
      desc: (
        <>
          Download 1 page Quick pitch to{" "}
          <p className={styles["underline-run"]}>Get involved</p>
        </>
      ),
      bg: true,
    },
  ];

  const handleBoxClick = (box) => {
    setOpenModal(box.title);
  };

  const closeModal = () => setOpenModal(null);

  return (
    <div>
      <div className={styles.signUpContainer}>
        <div className={styles.StartMain}>
          <div>
            {/* floating ellipses */}
            <img src="Images/Ellipse 1.png" alt="Ellipse 1" />
            <img src="Images/Ellipse 2.png" alt="Ellipse 2" />
            <img src="Images/Ellipse 5.png" alt="Ellipse 5" />
            <img src="Images/Ellipse 3.png" alt="Ellipse 3" />
            <img src="Images/Ellipse 4.png" alt="Ellipse 4" />
            <img src="Images/Ellipse 6.png" alt="Ellipse 6" />
            <img src="Images/Ellipse 7.png" alt="Ellipse 7" />
            <img src="Images/Ellipse 8.png" alt="Ellipse 8" />
            <img src="Images/Ellipse 9.png" alt="Ellipse 9" />
            <img src="Images/Ellipse 10.png" alt="Ellipse 10" />
            <img src="Images/Ellipse 11.png" alt="Ellipse 11" />
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.LogoDiv}>
            <img src="/Svg/rexpt-logo.svg" alt="Rexpt-Logo" />
          </div>
          <div className={styles.titleDiv}>
            <h1>Easy & Affordable Multichannel AI Solutions</h1>
            <p>
              Rexpt provides a unified Customer experience on{" "}
              <span className={styles.ForBold}>
                Phone Call, Chat & WhatsApp
              </span>
            </p>
          </div>
          <div className={styles.wrapper}>
            <div className={styles.gridWrapper}>
              {boxes.map((box, i) => (
                <div
                  key={i}
                  className={`${styles.boxCard} ${
                    box.bg ? styles.primary : ""
                  }`}
                  onClick={() => handleBoxClick(box)}
                >
                  <img src={box.icon} alt={box.title} className={styles.icon} />
                  <h3 className={styles.title}>{box.title}</h3>
                  <p className={styles.desc}>{box.desc}</p>
                </div>
              ))}
            </div>

            <div
              className={styles.callBtn}
              onClick={() => {
                clickAgentButton();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  clickAgentButton();
                }
              }}
            >
              <img src="/Svg/btn-shape2.svg" alt="btn-shape" />
              <div className={styles.textContent}>
                <h4>CALL REX</h4>
                <p>to answer your queries</p>
              </div>
              <div className={styles.rex}>
                <img src="/Images/rexicon.png" alt="REX" />
              </div>
            </div>
            <p className={styles.LastDes}>
              Get the most{" "}
              <a
                href="#"
                onClick={() => {
                  clickAgentButton();
                }}
              >
                Intelligent & Pre-Trained
              </a>{" "}
              Receptionist, Superfast!
            </p>
          </div>
        </div>
      </div>
      <Modal1
        open={openModal === "Investment Pitch"}
        onClose={closeModal}
        subTitle="Access our"
        title="Investment 1 pager"
      >
        <InvestmentForm
          formType="Investment Pitch"
          onClose={closeModal}
          onSuccess={(email) => showThankYou(email, "Investment Pitch")}
        />
      </Modal1>

      <Modal1
        open={openModal === "Enterprise Solution"}
        onClose={closeModal}
        subTitle="Explore Our"
        title="Enterprise Solutions"
      >
        <EnterpriseForm
          formType="Enterprise Solution"
          onClose={closeModal}
          onSuccess={(email) => showThankYou(email, "Enterprise Solution")}
        />
      </Modal1>

      <Modal1
        open={openModal === "Reseller Program"}
        onClose={closeModal}
        subTitle="Build Business with"
        title="Reseller Program"
      >
        <ResellerForm
          formType="Reseller Program"
          onClose={closeModal}
          onSuccess={(email) => showThankYou(email, "Reseller Program")}
        />
      </Modal1>

      <Modal1
        open={openModal === "Whitelabel"}
        onClose={closeModal}
        subTitle="Boost profits with our"
        title="Whitelabel Solution"
      >
        <WhiteLabelForm
          formType="Whitelabel"
          onClose={closeModal}
          onSuccess={(email) => showThankYou(email, "Whitelabel")}
        />
      </Modal1>

      <ThankYouModal
        open={thankYouOpen}
        onClose={closeThankYou}
        onTryAgain={handleTryAgain}
        email={userEmail}
        formType={lastFormTitle}
      />
    </div>
  );
};

export default GetInvolved;
